import { useState } from 'react';
import { useAuth } from '../../../lib/auth';

export const useLoginPresenter = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async () => {
    setLoading(true);
    setError(null);
    try {
      await login(username, password);
    } catch (e:any) {
      setError(e.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return { state: { username, password, loading, error }, actions: { setUsername, setPassword, onSubmit } };
};
